/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Field_BlankInputs */

const es_co2_error_field_blank = /** @type {(inputs: Error_Field_BlankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este campo es obligatorio.`)
};

/**

* @param {Error_Field_BlankInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_field_blank = /** @type {((inputs?: Error_Field_BlankInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Field_BlankInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_field_blank(inputs)
});